import {Action, ReduxList} from "app/types/app-types"
import {InpaintingGroupType, WatermarkGroupType} from "../products/types";

const SET_WATERMARK_GROUPS_TO_STORE = 'SET_WATERMARK_GROUPS_TO_STORE'
const SET_INPAINTING_GROUPS_TO_STORE = 'SET_INPAINTING_GROUPS_TO_STORE'

export type WatermarkGroupsType = ReduxList<WatermarkGroupType>
export type InpaintingGroupsType = ReduxList<InpaintingGroupType>

const defaultWatermarkGroupsState: WatermarkGroupsType = {
    data: [],
    isLoaded: false,
    isLoading: false,
    error: null,
    updated: null,
}

const defaultInpaintingGroupsState: InpaintingGroupsType = {
    data: [],
    isLoaded: false,
    isLoading: false,
    error: null,
    updated: null,
}

export function watermarkGroupsReducer(state: WatermarkGroupsType = defaultWatermarkGroupsState, action: Action<any>): WatermarkGroupsType {
    switch (action.type) {
        case SET_WATERMARK_GROUPS_TO_STORE:
            return {...state, ...{data: action.payload, isLoaded: true, isLoading: false, updated: new Date()} }
        default:
            return state
    }
}

export function inpaintingGroupsReducer(state: InpaintingGroupsType = defaultInpaintingGroupsState, action: Action<any>): InpaintingGroupsType {
    switch (action.type) {
        case SET_INPAINTING_GROUPS_TO_STORE:
            return {...state, ...{data: action.payload, isLoaded: true, isLoading: false, updated: new Date()} }
        default:
            return state
    }
}

export function setWatermarkGroupsToStore(watermarkGroups: WatermarkGroupType[]): Action<WatermarkGroupType[]> {
    return {
        type: SET_WATERMARK_GROUPS_TO_STORE,
        payload: watermarkGroups
    }
}

export function setInpaintingGroupsToStore(inpaintingGroups: InpaintingGroupType[]): Action<InpaintingGroupType[]> {
    return {
        type: SET_INPAINTING_GROUPS_TO_STORE,
        payload: inpaintingGroups
    }
}
